import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Index from '@/components/Index'
import Index_result from '@/components/Index_result'

import Harvest from '@/components/Harvest'
import subject from '@/components/harvest/subject'
import fund from '@/components/harvest/fund'
import yearbook from '@/components/harvest/yearbook'
import periodical from '@/components/harvest/periodical'
import award from '@/components/harvest/award'
import memorabilia_ from '@/components/harvest/memorabilia'
import beijing from '@/components/harvest/beijing'
import tianjinHebei from '@/components/harvest/tianjin_hebei'
import yunhe from '@/components/harvest/canal_'

import social_sciences from '@/components/harvest/social_sciences'
import literature from '@/components/harvest/literature'
import canal from '@/components/harvest/canal'
import database from '@/components/harvest/database'


import details from '@/components/details'
import subject_details from '@/components/detail/subject_details'
import fund_details from '@/components/detail/fund_details'
import yearbook_details from '@/components/detail/yearbook_details'
import journal_details from '@/components/detail/journal_details'
import award_details from '@/components/detail/award_details'
import canal_details from '@/components/detail/canal_details'
import beijing_details from '@/components/detail/beijing_details'
import tianjin_details from '@/components/detail/tianjin_details'
//import details from '@/components/details'
import readOnLine from '@/components/readOnLine'
import hot from '@/components/hot'
import register from '@/components/register'
import changePass from '@/components/changePass'

import memorabilia from '@/components/memorabilia'
import memorabilia_img from '@/components/memorabilia_img'

Vue.use(Router)
export default new Router({
    routes: [
        { path: '*', redirect: '/login' },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
        {
            path: '/changePass',
            name: 'changePass',
            component: changePass
        },
        {
            path: '/Index',
            name: 'Index',
            component: Index,
        },
        {
            path: '/Index_result',
            name: 'Index_result',
            component: Index_result,
        },
        {
            path: '/Harvest',
            name: 'Harvest',
            component: Harvest,
            children: [{
                    path: '/Harvest/subject',
                    name: 'subject',
                    component: subject,
                },
                {
                    path: '/Harvest/fund',
                    name: 'fund',
                    component: fund,
                },
                {
                    path: '/Harvest/yearbook',
                    name: 'yearbook',
                    component: yearbook,
                },
                {
                    path: '/Harvest/periodical',
                    name: 'periodical',
                    component: periodical,
                },
                {
                    path: '/Harvest/award',
                    name: 'award',
                    component: award,
                },
                {
                    path: '/Harvest/beijing',
                    name: 'beijing',
                    component: beijing,
                },
                {
                    path: '/Harvest/tianjinHebei',
                    name: 'tianjinHebei',
                    component: tianjinHebei,
                },
                {
                    path: '/Harvest/memorabilia',
                    name: 'memorabilia_',
                    component: memorabilia_,
                },
                //		        {
                //		            path: '/Harvest/literature',
                //		            name: 'literature',
                //		            component: literature,
                //		        },
                {
                    path: '/Harvest/canal',
                    name: 'yunhe',
                    component: yunhe,
                }
                //		        {
                //		            path: '/Harvest/database',
                //		            name: 'database',
                //		            component: database,
                //		        }
            ]
        },
        {
            path: "/details",
            name: 'details',
            component: details
        },
        {
            path: "/subject_details",
            name: 'subject_details',
            component: subject_details
        },
        {
            path: "/fund_details",
            name: 'fund_details',
            component: fund_details
        },
        {
            path: "/yearbook_details",
            name: 'yearbook_details',
            component: yearbook_details
        },
        {
            path: "/journal_details",
            name: 'journal_details',
            component: journal_details
        },
        {
            path: "/award_details",
            name: 'award_details',
            component: award_details
        },
        {
            path: "/canal_details",
            name: 'canal_details',
            component: canal_details
        },
        {
            path: "/beijing_details",
            name: 'beijing_details',
            component: beijing_details
        },
        {
            path: "/tianjin_details",
            name: 'tianjin_details',
            component: tianjin_details
        },
        {
            path: "/readOnLine",
            name: 'readOnLine',
            component: readOnLine
        },
        {
            path: "/hot",
            name: 'hot',
            component: hot
        },
        {
            path: "/memorabilia",
            name: 'memorabilia',
            component: memorabilia
        },
        {
            path: "/memorabilia_img",
            name: 'memorabilia_img',
            component: memorabilia_img
        }


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js